import React from 'react'
import P2PPageComponent from '../components/p2p'

function P2PPage() {
  return (
    <div className='px-4'><P2PPageComponent /></div>
  )
}

export default P2PPage